export default __webpack_public_path__ + "static/media/MDX-WHT.aca0a959.png";